// extracted by mini-css-extract-plugin
export default {"main":"UserProfile_main__q72KM","wrapper":"UserProfile_wrapper__U4xNZ","formWrapper":"UserProfile_formWrapper__i-OpV","title":"UserProfile_title__QmXy3"};